import { COLORS } from '@/theme';

export const highlightText = (text: string, search: string) => {
  if (!search) return text;
  const regex = new RegExp(`(${search})`, 'gi');
  return text.split(regex).map((part, index) => (
    <span key={index} style={{ color: regex.test(part) ? COLORS.ANT_DEFAULT_ACCENT : '#000' }}>
      {part}
    </span>
  ));
};
